import { createAction } from '@reduxjs/toolkit'

import {
  FunnelStage,
  TDashboardWidget,
  TDashboardWidgetFullyLoaded,
  TDashboardWidgetSettingsLoaded
} from 'types/GlobalWidget'
import { ILayoutItem } from 'types/GlobalDashboard'
import { TParsedError } from 'utils/errorParser'

// tryPutFunnelStages
export const putFunnelStages = createAction('put_funnel_stages')
export const putFunnelStagesSuccess = createAction<{
  id: string
  data: FunnelStage[]
}>('put_funnel_stages_success')
export const putFunnelStagesFailed = createAction('put_funnel_stages_failed')

// tryGetOneWidget, tryGetOnePublicWidget, tryGetOneApiAccessWidget
export const getOne = createAction<{
  id: string
  dashboardId: string
  fetchId: string
}>('get_one_widget')
export const getOneSuccess = createAction<{
  data: TDashboardWidgetFullyLoaded
  fetchId: string
}>('get_one_widget_success')
export const getOneFailed = createAction<{
  widgetId: string
  fetchId: string
  error: TParsedError
}>('get_one_widget_failed')

// tryCreateWidget
export const create = createAction('create_widget')
export const createSuccess = createAction<{
  data: TDashboardWidgetSettingsLoaded
  available_space: ILayoutItem | null
}>('create_widget_success')
export const createFailed = createAction('create_widget_failed')

// tryDeleteWidget
export const destroy = createAction('destroy_widget')
export const destroySuccess = createAction<{
  id: string
  dashboardId: string
  available_space: ILayoutItem | null
}>('destroy_widget_success')
export const destroyFailed = createAction('destroy_widget_failed')

// tryUploadWidgetImage
export const uploadImage = createAction('upload_image')
export const uploadImageSuccess = createAction<TDashboardWidget>(
  'upload_image_success'
)
export const uploadImageFailed = createAction('upload_image_failed')
